import { render, staticRenderFns } from "./ChooseDealer.vue?vue&type=template&id=571677c3&scoped=true"
import script from "./ChooseDealer.vue?vue&type=script&lang=js"
export * from "./ChooseDealer.vue?vue&type=script&lang=js"
import style0 from "./ChooseDealer.vue?vue&type=style&index=0&id=571677c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571677c3",
  null
  
)

export default component.exports